import { Flex } from "@mantine/core";
import { useUnreadMessagesCount } from "hooks/useUnreadMessagesCount";
import IconMessageDotsCircle from "icons/common/message-dots-circle.svg";
import { useChatPanelStore } from "stores/chatPanel";

export const OpenChatButton = () => {
  const { unreadMessagesCount, isChatEnabled } = useUnreadMessagesCount();
  const isPanelOpen = useChatPanelStore(store => store.isPanelOpen);
  const setIsPanelOpen = useChatPanelStore(store => store.setIsPanelOpen);

  if (!isChatEnabled) return null;

  return (
    <button
      type="button"
      aria-label="Open chat"
      className="m-2 relative cursor-pointer"
      onClick={() => setIsPanelOpen(!isPanelOpen)}
    >
      {unreadMessagesCount > 0 ? (
        <MessageIconWithBadge unreadMessagesCount={unreadMessagesCount} />
      ) : (
        <IconMessageDotsCircle width={24} height={24} color="black" />
      )}
    </button>
  );
};

const MessageIconWithBadge = ({
  unreadMessagesCount,
}: {
  unreadMessagesCount: number;
}) => (
  <>
    <Flex
      justify="center"
      align="center"
      fz={10}
      w={16}
      h={16}
      bg={"var(--color-blue)"}
      className="text-white rounded-full absolute top-0 left-0 transform -translate-x-1/4 -translate-y-1/5 z-2  pointer-events-none"
    >
      {unreadMessagesCount}
    </Flex>
    <IconMessageDotsCircle width={24} height={24} color="var(--color-blue)" />
  </>
);
